import {Component, Injectable, OnInit} from '@angular/core';
import {PublicService} from '../public.service';
import {Router} from '@angular/router';
import {DoCheck, AfterViewInit} from '@angular/core';
import {Http, HttpModule, Headers, RequestOptions, Response} from '@angular/http';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {HttpClient} from '@angular/common/http';
import {FormControl, Validators} from '@angular/forms';

declare const L: any;
let marker: any;
let myMap: any;

@Component({
  selector: 'app-get-location',
  templateUrl: './get-location.component.html',
  styleUrls: ['./get-location.component.scss']
})

@Injectable()
export class GetLocationComponent implements OnInit {
  city = "";
  formattedData = "";
  display = "deactive";
  displayAlert = "deactive-alert";
  displayTitr1 = "active-titr";
  displayTitr2 = "deactive-titr";
  loading = false;

  address = new FormControl('', [
    Validators.required,
  ]);

  constructor(private httpClient: HttpClient, private http: Http, public dialog: MatDialog, public snackbar: MatSnackBar, public publicservice: PublicService, public router: Router) {
    // if (publicservice.logedIn == 'false' || this.publicservice.logedIn == null) {
    //     this.router.navigate(['login']);
    // }
  }

  private extractData(res: Response, that: any) {
    if (res.status < 200 || res.status >= 300) {
      throw new Error('Bad response status: ' + res.status);
    }
    let body = res.json();

    if (body.error) {
      that.DisplayErrorDialog(body.message);
      Promise.reject(body.error);
    } else {
      return body || {};
    }
  }

  private handleError(error: any) {

    // In a real world app, we might send the error to remote logging infrastructure
    let errMsg = JSON.parse(error._body);

    console.error(errMsg); // log to console instead
    return Promise.reject(errMsg);
  }

  doneclick() {
    this.router.navigate(['waste-list']);

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // console.log('after view init');
    const span = document.getElementsByClassName('close')[0];
    const container = document.getElementById('map');
    if (container) {
      // code to render map here...
      myMap = new L.Map('map', {
        key: 'web.QQdvTPfUdyUpMeM1vdxMuYplZawtuMCsuAP2d0Ft',
        maptype: 'dreamy',
        poi: true,
        traffic: false,
        center: [33.984706, 51.427989],
        zoom: 14
      });
      marker = L.marker([33.984706, 51.427989]).addTo(myMap);
      myMap.on('click', this.onMapClick);
    }
  }

  onMapClick = (e: any) => {
    this.loading = true;
    let http = this.http;
    console.log(http);
    const lat = (e.latlng.lat);
    const lng = (e.latlng.lng);
    const newLatLng = new L.LatLng(lat, lng);
    marker.setLatLng(newLatLng);
    let body = JSON.stringify({});
    let headers = new Headers({
      'Api-Key': 'service.FmboMtDxzLzYnRm2gRsXDi1jojZftDvosFjHuOTW',
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({headers: headers});
    let ret: Promise<any> = http.get(`https://api.neshan.org/v2/reverse?lat=${lat}&lng=${lng}`, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret.then(r => {
      this.loading = false;
      let modal = document.getElementById('myModal');
      // handle success
      // console.log(r);
      let statusCode = r['status'];
      if (statusCode === 200) {
        // var dataJson = response.data;
        this.formattedData = r.formatted_address;
        //                     prompt("aaa", formattedData);
        // modal.style.display = 'block';
        console.log(this.formattedData);

        // document.getElementById('myText').value = this.formattedData;
      } else if (statusCode === 470) {
        alert('مختصات جغرافیایی ارسالی معتبر نمی باشد.');
      } else if (statusCode == 'OK') {
        this.formattedData = r.addresses[0].formatted;
        localStorage.setItem("location", this.formattedData);
        this.publicservice.location = this.formattedData;
        this.city = r.state;
        // if (this.city == "استان سمنان") {
        this.display = "active";
        this.displayAlert = "active-alert";
        // } else {
        //   alert("این برنامه در شهر شما کار نمیکند، امیدواریم به زودی بتوانیم در شهر شما هم این سرویس را راه اندازی کنیم");
        //
        //   //                     prompt("aaa", formattedData);
        //   // modal.style.display = 'block';
        //   // alert(this.formattedData);
        //   console.log("on map clickkkkkk");
        //
        //
        // }
      } else {
        alert('خطایی در مکانیابی رخ داده است. لطفا کمی صبر کنید.');
      }

    })
      .catch(function (error) {
        // handle error
        console.log(error);
      });
  };


  showLocation = (position: any) => {
    this.loading = true;
    let http = this.http;
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    const newLatLng = new L.LatLng(latitude, longitude);
    marker.setLatLng(newLatLng);
    myMap.setView([latitude, longitude], 18);
    let body = JSON.stringify({});
    let headers = new Headers({
      'Api-Key': 'service.FmboMtDxzLzYnRm2gRsXDi1jojZftDvosFjHuOTW',
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({headers: headers});
    let ret: Promise<any> = http.get(`https://api.neshan.org/v2/reverse?lat=${latitude}&lng=${longitude}`, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret.then(r => {
      this.loading = false;
      let modal = document.getElementById('myModal');
      // handle success
      // console.log(r);
      let statusCode = r['status'];
      if (statusCode === 200) {
        // var dataJson = response.data;
        this.formattedData = r.formatted_address;
        //                     prompt("aaa", formattedData);
        // modal.style.display = 'block';
        console.log(this.formattedData);

        // document.getElementById('myText').value = this.formattedData;
      } else if (statusCode === 470) {
        alert('مختصات جغرافیایی ارسالی معتبر نمی باشد.');
      } else if (statusCode == 'OK') {
        this.formattedData = r.addresses[0].formatted;
        localStorage.setItem("location", this.formattedData);
        this.publicservice.location = this.formattedData;
        this.city = r.state;
        // if (this.city == "استان سمنان") {
        this.display = "active";
        this.displayAlert = "active-alert";
        // } else {
        //   alert("این برنامه در شهر شما کار نمیکند، امیدواریم به زودی بتوانیم در شهر شما هم این سرویس را راه اندازی کنیم");

        //                     prompt("aaa", formattedData);
        // modal.style.display = 'block';
        // alert(this.formattedData);
        // console.log("on map clickkkkkk");


        // }
      } else {
        alert('خطایی در مکانیابی رخ داده است. لطفا کمی صبر کنید.');
      }
    })
      .catch(function (error) {
        // handle error
        console.log(error);
      });
  };

  errorHandler = (err: any) => {
    if (err.code === 1) {
      // alert('Error: Access is denied!');
      this.display = "active";
      this.displayAlert = "active-alert";
      this.displayTitr1 = "deactive-titr";
      this.displayTitr2 = "active-titr";
    } else if (err.code === 2) {
      // alert('Filtering');
      this.display = "active";
      this.displayAlert = "active-alert";
      this.displayTitr1 = "deactive-titr";
      this.displayTitr2 = "active-titr";
    }
  }

  getLocation() {
    if (navigator.geolocation) {
      // timeout at 60000 milliseconds (60 seconds)
      const options = {timeout: 60000};
      navigator.geolocation.getCurrentPosition(this.showLocation, this.errorHandler, options);
    } else {
      alert('Sorry, browser does not support geolocation!');
    }
  }


  closeClick() {
    this.display = "deactive";
  }

  okClick() {
    // this.publicservice.location = this.formattedData;
    // console.log("bbbbbbbbbb");
    localStorage.setItem("location", this.publicservice.location);
    // let a = localStorage.getItem("location");
    // console.log(a)
    if (this.publicservice.location != "") {
      // this.router.navigate(['services']);
      this.router.navigate(['waste-list']);
    } else {
      // console.log("333333333");

    }

  }


}
